import { useState } from "react";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";
import Button from "../Button";
import Text from "../Typography/Text";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import Logo from "../Logo";
import { usePage } from "@hooks/usePage";
import { config } from "@/config";
import { useNavigate } from "react-router-dom";

function HeaderMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState<Record<string, boolean>>({});
  const { activePage } = usePage();
  const navigate = useNavigate();

  const handleToggleSubmenu = (label: string) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const handleClick = (path?: string) => {
    if (path) {
      navigate(path);
    }
    setIsMenuOpen(false);
  };

  return (
    <div className="md:hidden">
      <IconButton
        onClick={() => setIsMenuOpen((prev) => !prev)}
        aria-label="Abrir menu"
      >
        {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
      {isMenuOpen && (
        <nav
          className={`absolute z-50 top-0 left-0 h-full w-3/4 max-w-xs bg-white shadow-lg p-6 flex flex-col gap-4 ${
            isMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between">
            <Logo />
            <IconButton
              onClick={() => setIsMenuOpen(false)}
              aria-label="Fechar menu"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <List className="space-y-3 w-full overflow-y-auto">
            {config.pages.map((item) => {
              if (item.outsideMenu) return null;
              return item.subpages ? (
                <div key={item.label}>
                  <div className="bg-background rounded-3xl">
                    <Button
                      customVariant="muted"
                      size="full"
                      onClick={() => handleToggleSubmenu(item.label)}
                    >
                      <div className="flex-1 text-center">
                        <Text>{item.label}</Text>
                      </div>
                      <span className="absolute right-4">
                        {openSubmenus[item.label] ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                      </span>
                    </Button>
                    <Collapse
                      in={openSubmenus[item.label]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List
                        component="div"
                        disablePadding
                        className="pt-2 pb-3 space-y-2 px-4"
                      >
                        {item.subpages.map((sub) => (
                          <Button
                            key={sub.label}
                            customVariant={
                              activePage === sub.label ? "primary" : "muted"
                            }
                            size="full"
                            className="text-md"
                            onClick={() => handleClick(sub.path)}
                          >
                            <Text size="sm">{sub.label}</Text>
                          </Button>
                        ))}
                      </List>
                    </Collapse>
                  </div>
                </div>
              ) : (
                <ListItem disablePadding key={item.label}>
                  <Button
                    customVariant={
                      activePage === item.label ? "primary" : "muted"
                    }
                    size="full"
                    onClick={() => handleClick(item.path)}
                  >
                    <Text>{item.label}</Text>
                  </Button>
                </ListItem>
              );
            })}
          </List>
        </nav>
      )}
    </div>
  );
}

export default HeaderMenu;
